import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Content", "filtersFromTemplate", "flow", "flowObjectTypeId", "readOnly", "isDisabled", "showLoadingOverlay", "bannerStyle", "layout", "overrideTitleAction"];
import styled, { useTheme } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import EnrollmentCardContent from 'automation-ui-canvas/components/enrollment/EnrollmentCardContent';
import PasteAfterVirtualActionButton from 'automation-ui-canvas/components/canvas/copyPaste/PasteAfterVirtualActionButton';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import ActionDetailsButton from 'automation-ui-action-features/action-details/ActionDetailsButton';
import DetailsPopoverContent from 'automation-ui-action-features/action-details/DetailsPopoverContent';
import DetailsPopoverSection from 'automation-ui-action-features/action-details/DetailsPopoverSection';
import ReenrollmentView from 'automation-ui-canvas/components/enrollment/ReenrollmentView';
import { Flex } from 'foundations-components/components/Flex';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VerticalRule = styled.div.withConfig({
  displayName: "EnrollmentCard__VerticalRule",
  componentId: "dxopul-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    height: '100%',
    borderLeft: `1px solid ${theme.color['border-core-default']}`,
    marginInline: theme.space['300']
  };
});
export const EnrollmentCard = _ref => {
  let {
      Content = EnrollmentCardContent,
      filtersFromTemplate,
      flow,
      flowObjectTypeId,
      readOnly,
      isDisabled,
      showLoadingOverlay,
      bannerStyle,
      layout,
      overrideTitleAction
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const isObjectlessWorkflow = getIsObjectlessFlow(flow.toHybridFlowInterface());
  const icon = 'contactProperties';
  const title = flowObjectTypeId === UNKNOWN_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "enrollment.canvas.headerUnknownObject"
  }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "enrollment.canvas.header_cob",
    objectTypeId: flowObjectTypeId
  });
  const content = /*#__PURE__*/_jsx(Content, {
    filtersFromTemplate: filtersFromTemplate,
    flow: flow,
    readOnly: readOnly
  });
  const titleAction = () => {
    const isScheduledFlow = flow.hasEnrollmentSchedule();
    const isDateBasedFlow = !!flow.getClassicEnrollmentSettings() && !!flow.getClassicEnrollmentSettings().eventAnchor;
    const shouldShowPasteButton = !(isScheduledFlow || isDateBasedFlow) && !readOnly && !isDisabled;
    const renderedTitleAction = shouldShowPasteButton ?
    /*#__PURE__*/
    // @ts-expect-error using function to return component is allowed here
    _jsx(PasteAfterVirtualActionButton, {
      flow: flow,
      showLoadingOverlay: showLoadingOverlay,
      nodeId: SpecialActionIds.ENROLLMENT,
      buttonUse: "link-on-bright"
    }) : null;
    const ActionDetailsButtonContent = () => /*#__PURE__*/_jsx(DetailsPopoverContent, {
      headerIconName: icon,
      headerTitle: title,
      theme: "default",
      statusIcon: "success",
      statusColor: theme.color['fill-positive-default'],
      statusText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrollment.canvas.popover.status"
      }),
      children: /*#__PURE__*/_jsx(DetailsPopoverSection, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrollment.canvas.popover.explainerHeading"
        }),
        children: content
      })
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [
      // Always render something so the details popover gets pushed to the right
      renderedTitleAction || /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        alignSelf: "stretch",
        children: [layout !== 'zoomed-out' && /*#__PURE__*/_jsx(_Fragment, {
          children: !isObjectlessWorkflow && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(ReenrollmentView, {
                flow: flow.toHybridFlowInterface()
              })
            }), /*#__PURE__*/_jsx(VerticalRule, {})]
          })
        }), /*#__PURE__*/_jsx(ActionDetailsButton, {
          use: layout === 'zoomed-out' ? 'icon' : 'link',
          "data-test-id": `card-details-toggle-${SpecialActionIds.ENROLLMENT}`,
          trackingIdentifier: SpecialActionIds.ENROLLMENT,
          Content: ActionDetailsButtonContent
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerIcon: icon,
    headerTitle: title,
    content: content,
    titleUseTheme: "default",
    "data-test-id": "enrollment-action",
    TitleAction: overrideTitleAction !== null && overrideTitleAction !== void 0 ? overrideTitleAction : titleAction,
    isDisabled: isDisabled,
    bannerStyle: bannerStyle || 'success',
    layout: layout,
    showIconCircle: false
  }));
};
export default EnrollmentCard;